var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8016 21.7984H5.60156C5.07113 21.7984 4.56242 21.5877 4.18735 21.2127C3.81228 20.8376 3.60156 20.3289 3.60156 19.7984V4.39844C3.60156 3.868 3.81228 3.3593 4.18735 2.98422C4.56242 2.60915 5.07113 2.39844 5.60156 2.39844H14.6016L19.6016 7.39844V11.6118",
    stroke: "#707494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5977 2.39844V6.39844C13.5977 6.92887 13.8084 7.43758 14.1834 7.81265C14.5585 8.18772 15.0672 8.39844 15.5977 8.39844H19.5977",
    stroke: "#707494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0285 13.7018C12.0006 13.636 11.993 13.5634 12.0066 13.4933C12.0202 13.4231 12.0545 13.3587 12.105 13.3081C12.1555 13.2576 12.22 13.2233 12.2901 13.2097C12.3603 13.1961 12.4329 13.2037 12.4987 13.2316L20.4187 16.4716C20.4892 16.5005 20.5487 16.5511 20.5886 16.616C20.6285 16.6808 20.6469 16.7567 20.6409 16.8327C20.635 16.9086 20.6052 16.9808 20.5556 17.0387C20.5061 17.0966 20.4395 17.1373 20.3654 17.1549L17.2341 17.9044C17.1048 17.9353 16.9866 18.0014 16.8926 18.0953C16.7986 18.1892 16.7324 18.3073 16.7013 18.4365L15.9525 21.5685C15.9351 21.6429 15.8944 21.7098 15.8364 21.7595C15.7784 21.8092 15.7061 21.8393 15.63 21.8452C15.5538 21.8511 15.4778 21.8327 15.4128 21.7925C15.3478 21.7524 15.2973 21.6926 15.2685 21.6218L12.0285 13.7018Z",
    stroke: "#707494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFile);
export default __webpack_public_path__ + "static/media/selectFile.d4476601377741c65371b5e2d1c4dd60.svg";
export { ForwardRef as ReactComponent };